<div class="position-reletivediv popup-inner-space">
    <div class="text-right">
        <img src="assets/images/close.svg" class="img-fluid closeicon closeicon2 cursor-pointer" alt="..." (click)="Close()">
    </div>

    <form class="" [formGroup]="setparameterForm" (ngSubmit)="OnSubmit()">
        <div class="errmsg" *ngIf="errorMsg">{{errorMsg}}</div>
        <div class="sucessmsg" *ngIf="successMsg">{{successMsg}}</div>
        <div class="betweenheader margin-top-20">
            Threshold value 
        </div>

        <div class="fxg-field margin-top-5">
            <label style="display:none;" class="Navuser">Energy
            </label>
            <input type="text" class="fxg-field__input-text12 fxg-field__input--required sessioncamexclude"
                formControlName="ThresholdEnergy" id="ThresholdEnergy" name="ThresholdEnergy" title="Energy"
                NumberWithDecimal maxlength="50" required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly1}"
                data-errmsg="Sorry, this is a required field.">
            <span class="fxg-field__placeholder fxg-field__floating-placeholder fxg-field__placeholder12" tabindex="-1">Energy</span>
        </div>

        <div class="fxg-field margin-top-20">
            <label style="display:none;" class="Navuser">MDI
            </label>
            <input type="text" class="fxg-field__input-text12 fxg-field__input--required sessioncamexclude"
                formControlName="ThresholdMDI" id="ThresholdMDI" name="ThresholdMDI" title="MDI" NumberWithDecimal
                maxlength="50" required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly1}"
                data-errmsg="Sorry, this is a required field.">
            <span class="fxg-field__placeholder fxg-field__floating-placeholder fxg-field__placeholder12" tabindex="-1">MDI</span>
        </div>

        <div class="fxg-field margin-top-20" style="display: none;">
            <label style="display:none;" class="Navuser">Temprature
            </label>
            <input type="text" class="fxg-field__input-text12 fxg-field__input--required sessioncamexclude"
                formControlName="ThresholdTemperature" id="ThresholdTemperature" name="ThresholdTemperature" title="Temprature"
                NumberWithDecimal maxlength="50" required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly1}"
                data-errmsg="Sorry, this is a required field.">
            <span class="fxg-field__placeholder fxg-field__floating-placeholder fxg-field__placeholder12" tabindex="-1">Temprature</span>
        </div>


        <div class="fxg-field margin-top-20" style="display: none;">
            <label style="display:none;" class="Navuser">Humidity
            </label>
            <input type="text" class="fxg-field__input-text12 fxg-field__input--required sessioncamexclude"
                formControlName="ThresholdHumidity" id="ThresholdHumidity" name="ThresholdHumidity" title="Humidity"
                NumberWithDecimal maxlength="50" required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly1}"
                data-errmsg="Sorry, this is a required field.">
            <span class="fxg-field__placeholder fxg-field__floating-placeholder fxg-field__placeholder12" tabindex="-1">Humidity</span>
        </div>



        <div class="fxg-field margin-top-20">
            <label style="display:none;" class="Navuser">Power Factor
            </label>
            <input type="text" class="fxg-field__input-text12 fxg-field__input--required sessioncamexclude"
                formControlName="ThresholdPowerFactor" id="ThresholdPowerFactor" name="ThresholdPowerFactor" title="Power Factor"
                NumberWithDecimal maxlength="50" required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly1}"
                data-errmsg="Sorry, this is a required field.">
            <span class="fxg-field__placeholder fxg-field__floating-placeholder fxg-field__placeholder12" tabindex="-1">Power Factor</span>
        </div>

        <div class="fxg-field margin-top-20">
            <label style="display:none;" class="Navuser">Electricity Bill
            </label>
            <input type="text" class="fxg-field__input-text12 fxg-field__input--required sessioncamexclude"
                formControlName="ThresholdElectricityBill" id="ThresholdElectricityBill" name="ThresholdElectricityBill"
                title="Electricity Bill" NumberWithDecimal maxlength="50" required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly1}"
                data-errmsg="Sorry, this is a required field.">
            <span class="fxg-field__placeholder fxg-field__floating-placeholder fxg-field__placeholder12" tabindex="-1">Electricity Bill</span>
        </div>
        <div class="margin-top-20 save-cancel">
            <button class="btncommon" type="submit">Save</button>
            <button class="btncommon" (click)="OnCancel()">Cancel</button>
        </div>
    </form>
</div>